import React, {useEffect} from "react";
import Container from 'react-bootstrap/Container';
import '../Lg.css';
import {TildaB} from "./common/TildaB";
import {logPageOpened} from "../../model/utils";
import {calculateLeadGenerationUrl, calcWhere} from "./common/LgHelper";
import {appdata} from "../../../logic_tmp/appdata/AppData";


export function LgFullFooter() {
    appdata.viewType = "FullPage"
    useEffect(() => {
        logPageOpened(appdata.parentPath,appdata.viewType)
    }, []);
    return (
        <div>
            <Container>
                <TildaB>
                    <span className="normal">Мы собираемся организовать этот концерт в </span>
                    <strong><span><strong
                        className="normal">{calcWhere(appdata)}.</strong></span></strong>
                </TildaB>
                <TildaB>
                    <div className="fontBig center"> Приглашать ли вас на эти концерты?</div>
                </TildaB>
                <TildaB>
                    <div>
                        <a id="pleaseInviteMe" href={calculateLeadGenerationUrl(appdata)} target="_parent"
                           className="myButton myButtonYellow">Да, пригласите меня!</a>
                    </div>
                </TildaB>
            </Container>
        </div>
    );
}

